module.exports = __webpack_public_path__ + "static/media/fxIcon.02e415ea.svg";